import { useState } from 'react';
import { createStripeCheckout, getPriceIdFromSupabase } from '../../../lib/stripeCheckout';

interface Plano {
  id: string;
  nome: string;
  subtitulo: string;
  emoji: string;
  preco: number;
  badge: string;
  badgeColor: string;
  icon: string;
  descricao: string;
  recursos: string[];
  cta: string;
  popular?: boolean;
  premium?: boolean;
  nota?: string;
  influencer?: boolean;
}

const planos: Plano[] = [
  {
    id: 'semente',
    nome: 'SEMENTE DO FUTURO',
    subtitulo: 'Comece sua jornada sem custo',
    emoji: '💫',
    preco: 0,
    badge: 'GRATUITO',
    badgeColor: 'bg-emerald-600',
    icon: 'ri-seedling-line',
    descricao: 'Ideal para quem deseja experimentar a ferramenta e dar o primeiro passo rumo a uma vida mais consciente e direcionada.',
    recursos: [
      'Exercício básico de visualização do futuro',
      'Introdução à Ponte ao Futuro (PNL)',
      'Escrita de uma carta para 1 ano',
      'Armazenamento seguro da mensagem',
      'Entrega futura automática por e-mail',
      'Interface simples e intuitiva'
    ],
    cta: 'Começar Gratuitamente',
    nota: '👉 Perfeito para novos usuários'
  },
  {
    id: 'influencer',
    nome: 'PROGRAMA INFLUENCER',
    subtitulo: 'Parceria exclusiva para criadores de conteúdo',
    emoji: '✨',
    preco: 0,
    badge: 'INFLUENCER',
    badgeColor: 'bg-gradient-to-r from-pink-500 to-purple-600',
    icon: 'ri-star-smile-line',
    descricao: 'Acesso completo gratuito para influencers que desejam compartilhar a transformação com sua comunidade.',
    recursos: [
      'Acesso completo a todos os recursos premium',
      'Código exclusivo para seus seguidores',
      'Dashboard de métricas e conversões',
      'Destaque na plataforma como parceiro',
      'Suporte prioritário',
      'Material de divulgação personalizado',
      'Comissão por indicações (em breve)'
    ],
    cta: 'Quero Ser Parceira',
    influencer: true,
    nota: '⭐ Exclusivo para influencers'
  },
  {
    id: 'clareza',
    nome: 'CLAREZA',
    subtitulo: 'Defina a vida que deseja construir',
    emoji: '💎',
    preco: 97,
    badge: 'ESSENCIAL',
    badgeColor: 'bg-amber-600',
    icon: 'ri-lightbulb-flash-line',
    descricao: 'Para quem quer aprofundar a reflexão e estabelecer metas mais claras.',
    recursos: [
      'Tudo do plano Gratuito',
      'Áudio guiado completo de visualização',
      'Exercício estruturado da Ponte ao Futuro',
      'Escrita de cartas para até 3 datas diferentes',
      'Perguntas de autoconhecimento profundo',
      'Download das cartas',
      'Música imersiva durante a experiência',
      'Área pessoal com histórico'
    ],
    cta: 'Adquirir Clareza',
    popular: true
  },
  {
    id: 'direcao',
    nome: 'DIREÇÃO',
    subtitulo: 'Transforme intenção em plano de vida',
    emoji: '🌟',
    preco: 297,
    badge: 'EVOLUÇÃO',
    badgeColor: 'bg-rose-600',
    icon: 'ri-compass-3-line',
    descricao: 'Ideal para quem deseja alinhar propósito, metas e identidade futura.',
    recursos: [
      'Tudo do plano Essencial',
      'Exercícios avançados de clareza de propósito',
      'Linha do tempo de metas (1 a 5 anos)',
      'Checkpoints semestrais de reflexão',
      'Áudio de reprogramação mental',
      'Avaliação das principais áreas da vida',
      'Ferramenta de prioridades'
    ],
    cta: 'Encontrar Direção'
  },
  {
    id: 'identidade',
    nome: 'IDENTIDADE FUTURA',
    subtitulo: 'Torne-se a pessoa que precisa ser para viver sua vida ideal',
    emoji: '💎',
    preco: 697,
    badge: 'TRANSFORMAÇÃO',
    badgeColor: 'bg-purple-600',
    icon: 'ri-user-star-line',
    descricao: 'Uma imersão profunda na construção do seu "eu do futuro".',
    recursos: [
      'Tudo do plano Evolução',
      'Até 10 cartas programadas',
      'Diário digital da jornada futura',
      'Exercícios de mudança de identidade',
      'Visualizações por áreas da vida',
      'Planejamento estratégico pessoal',
      'Alertas e lembretes inspiracionais',
      'Revisões periódicas'
    ],
    cta: 'Transformar Identidade',
    premium: true
  },
  {
    id: 'legado',
    nome: 'VIDA EXTRAORDINÁRIA',
    subtitulo: 'Crie conscientemente o seu futuro de longo prazo',
    emoji: '🌙',
    preco: 1497,
    badge: 'LEGADO',
    badgeColor: 'bg-slate-700',
    icon: 'ri-trophy-line',
    descricao: 'Para quem deseja estrutura e profundidade.',
    recursos: [
      'Tudo dos planos anteriores',
      'Planejamento de vida em 5 anos',
      'Ferramentas de decisões estratégicas',
      'Carta anual automática',
      'Mapas de visão guiados',
      'Conteúdos exclusivos avançados',
      'Acompanhamento digital da evolução'
    ],
    cta: 'Criar Legado',
    premium: true
  },
  {
    id: 'private',
    nome: 'ACESSO EXCLUSIVO',
    subtitulo: 'Transformação personalizada',
    emoji: '💼',
    preco: 5000,
    badge: 'PRIVATE',
    badgeColor: 'bg-gradient-to-r from-amber-600 to-yellow-600',
    icon: 'ri-vip-crown-line',
    descricao: 'Experiência premium para pessoas que desejam orientação individual e resultados extraordinários.',
    recursos: [
      'Sessão individual guiada',
      'Planejamento de vida personalizado',
      'Análise profunda de objetivos',
      'Cartas estratégicas sob medida',
      'Acompanhamento exclusivo',
      'Possibilidade de envio físico premium',
      'Suporte prioritário'
    ],
    cta: 'Solicitar Aplicação',
    premium: true,
    nota: 'Sob aplicação — a partir de R$ 5.000'
  }
];

export default function PlanosGrid() {
  const [hoveredPlano, setHoveredPlano] = useState<string | null>(null);
  const [loadingCheckout, setLoadingCheckout] = useState<string | null>(null);

  const handleCheckout = async (planoId: string) => {
    if (planoId === 'semente') {
      // Plano gratuito - redireciona para formulário
      window.location.href = '/#formulario';
      return;
    }

    if (planoId === 'influencer') {
      // Plano influencer - redireciona para landing page exclusiva
      window.location.href = '/influencer';
      return;
    }

    if (planoId === 'private') {
      // Plano private - redireciona para formulário de aplicação
      window.location.href = '/planos#private';
      return;
    }

    setLoadingCheckout(planoId);
    try {
      const priceId = await getPriceIdFromSupabase(planoId);
      const currentUrl = window.location.origin;
      const checkoutUrl = await createStripeCheckout({
        priceId,
        mode: 'payment',
        successUrl: `${currentUrl}/planos/sucesso?plan=${planoId}`,
        cancelUrl: `${currentUrl}/planos?canceled=true`,
        metadata: { plan: planoId, type: 'one-time' },
      });
      
      window.location.href = checkoutUrl;
    } catch (error) {
      console.error('Erro ao processar pagamento:', error);
      alert('Erro ao processar pagamento. Por favor, tente novamente.');
      setLoadingCheckout(null);
    }
  };

  return (
    <section className="py-24 bg-gradient-to-b from-zinc-950 via-neutral-950 to-stone-950 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-amber-500/20 to-transparent"></div>

      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {planos.map((plano) => (
            <div
              key={plano.id}
              id={plano.id}
              onMouseEnter={() => setHoveredPlano(plano.id)}
              onMouseLeave={() => setHoveredPlano(null)}
              className={`relative rounded-3xl p-8 transition-all duration-500 border-2 ${
                plano.influencer
                  ? 'bg-gradient-to-br from-pink-950/50 to-purple-950/40 border-pink-500/50 shadow-[0_0_60px_rgba(236,72,153,0.15)] scale-105'
                  : plano.popular
                  ? 'bg-gradient-to-br from-amber-950/50 to-yellow-950/40 border-amber-500/50 shadow-[0_0_60px_rgba(251,191,36,0.15)] scale-105'
                  : hoveredPlano === plano.id
                  ? 'bg-gradient-to-br from-stone-900/70 to-zinc-900/70 border-amber-500/40 shadow-[0_0_40px_rgba(251,191,36,0.1)] -translate-y-2'
                  : 'bg-gradient-to-br from-stone-900/50 to-zinc-900/50 border-stone-700/50'
              }`}
            >
              {/* Badge */}
              {plano.influencer && (
                <div className="absolute -top-4 left-1/2 -translate-x-1/2">
                  <div className="bg-gradient-to-r from-pink-500 to-purple-600 text-white font-['Montserrat'] font-black text-xs px-6 py-2 rounded-full tracking-wider uppercase whitespace-nowrap shadow-xl">
                    <i className="ri-star-smile-fill mr-1"></i>
                    Exclusivo Influencers
                  </div>
                </div>
              )}

              {plano.popular && !plano.influencer && (
                <div className="absolute -top-4 left-1/2 -translate-x-1/2">
                  <div className="bg-gradient-to-r from-amber-500 to-amber-600 text-stone-950 font-['Montserrat'] font-black text-xs px-6 py-2 rounded-full tracking-wider uppercase whitespace-nowrap shadow-xl">
                    <i className="ri-star-fill mr-1"></i>
                    Mais Popular
                  </div>
                </div>
              )}

              {plano.badge && !plano.popular && !plano.influencer && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2">
                  <div className={`${plano.badgeColor} px-5 py-2 rounded-full shadow-lg`}>
                    <span className="text-xs font-bold text-white tracking-wider font-['Montserrat'] whitespace-nowrap">
                      {plano.badge}
                    </span>
                  </div>
                </div>
              )}

              <div className="pt-4">
                {/* Icon & Name */}
                <div className="flex items-center gap-3 mb-4">
                  <div className={`w-14 h-14 rounded-xl flex items-center justify-center shadow-lg ${
                    plano.influencer 
                      ? 'bg-gradient-to-br from-pink-500 to-purple-600' 
                      : plano.popular 
                      ? 'bg-gradient-to-br from-amber-500 to-amber-600' 
                      : 'bg-amber-500/10 border border-amber-500/20'
                  }`}>
                    <i className={`${plano.icon} text-2xl ${plano.influencer || plano.popular ? 'text-white' : 'text-amber-400'}`}></i>
                  </div>
                  <div>
                    <h3 className="font-['Playfair_Display'] text-xl font-bold text-stone-50">
                      {plano.nome}
                    </h3>
                  </div>
                </div>

                <p className="font-['Montserrat'] text-sm text-stone-400 mb-6 tracking-wide">
                  {plano.emoji} {plano.subtitulo}
                </p>

                {/* Preço */}
                <div className="mb-6 pb-6 border-b border-amber-500/10">
                  {plano.preco === 0 ? (
                    <div className="flex items-baseline gap-2">
                      <span className={`font-['Playfair_Display'] text-5xl font-bold ${plano.influencer ? 'text-pink-400' : 'text-stone-50'}`}>
                        R$ 0
                      </span>
                    </div>
                  ) : plano.id === 'private' ? (
                    <div>
                      <p className="font-['Montserrat'] text-xs text-stone-500 mb-1">Sob aplicação</p>
                      <span className="font-['Playfair_Display'] text-3xl font-bold text-amber-400">
                        a partir de R$ 5.000
                      </span>
                    </div>
                  ) : (
                    <div className="flex items-baseline gap-1">
                      <span className={`font-['Playfair_Display'] text-5xl font-bold ${plano.popular ? 'text-amber-400' : 'text-stone-50'}`}>
                        R$ {plano.preco.toLocaleString('pt-BR')}
                      </span>
                    </div>
                  )}
                </div>

                {/* Descrição */}
                <p className="font-['Montserrat'] text-sm text-stone-300 mb-6 leading-relaxed font-light">
                  {plano.descricao}
                </p>

                {/* Recursos */}
                <div className="space-y-3 mb-6">
                  {plano.recursos.map((recurso, idx) => (
                    <div key={idx} className="flex items-start gap-3">
                      <div className={`w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 ${
                        plano.influencer 
                          ? 'bg-pink-500/20 border border-pink-500/30' 
                          : 'bg-amber-500/20 border border-amber-500/30'
                      }`}>
                        <i className={`ri-check-line text-xs ${plano.influencer ? 'text-pink-400' : 'text-amber-400'}`}></i>
                      </div>
                      <span className="font-['Montserrat'] text-sm text-stone-300 font-light tracking-wide leading-relaxed">
                        {recurso}
                      </span>
                    </div>
                  ))}
                </div>

                {/* Nota */}
                {plano.nota && plano.id !== 'private' && (
                  <p className={`font-['Montserrat'] text-xs mb-5 italic ${
                    plano.influencer ? 'text-pink-400/70' : 'text-amber-400/70'
                  }`}>
                    {plano.nota}
                  </p>
                )}

                {/* CTA */}
                <button
                  onClick={() => handleCheckout(plano.id)}
                  disabled={loadingCheckout === plano.id}
                  className={`w-full py-4 rounded-xl font-['Montserrat'] font-bold text-sm transition-all duration-300 whitespace-nowrap cursor-pointer tracking-wider uppercase disabled:opacity-50 disabled:cursor-not-allowed ${
                    plano.influencer
                      ? 'bg-gradient-to-r from-pink-500 to-purple-600 text-white hover:shadow-[0_0_40px_rgba(236,72,153,0.3)] hover:scale-105'
                      : plano.popular
                      ? 'bg-gradient-to-r from-amber-500 to-amber-600 text-stone-950 hover:shadow-[0_0_40px_rgba(251,191,36,0.3)] hover:scale-105'
                      : 'border-2 border-amber-500/40 text-amber-400 hover:bg-amber-500/10 hover:border-amber-500/60'
                  }`}
                >
                  {loadingCheckout === plano.id ? (
                    <>
                      <i className="ri-loader-4-line animate-spin mr-2"></i>
                      Processando...
                    </>
                  ) : (
                    plano.cta
                  )}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
